import { Request } from "../base/models.jsx";
import { Coordinate } from "../../utils/geographics/models.jsx";

const SERVICE_ID = 5;

class ResidueType {

	constructor(jsonData) {
		if (jsonData == null)
			jsonData = {};
		
		this.id = jsonData.id;
		this.name = jsonData.name;
		this.isEnabled = jsonData.isEnabled;
	}

	isValid() {
		if (!this.name) return false;
		return true;
	}

}

class Appointment extends Request {

	constructor(jsonData) {
		if (jsonData == null) {
			jsonData = {};
			super(jsonData);
			this.creation();
		} else {
			super(jsonData);
		}

		this.contactInformation = new ContactInformation(jsonData.contactInformation);
		this.location = new Location(jsonData.location);
		this.communicationChannel = jsonData.communicationChannel;
		this.date = jsonData.date;

		this.details = [];
		if (jsonData.details != null) {
			for (let index = 0; index < jsonData.details.length; index++) {
				this.addDetail(new ResidueType(jsonData.details[index]));
			}
		}
	}

	getDate() {
		return new Date(this.date.year, this.date.month-1, this.date.day);
	}

	setDate(date) {
		this.date = {
			"year": date.getFullYear(),
			"month": date.getMonth()+1,
			"day": date.getDate()
		}
	}

	addDetail(residueType) {
		this.details.push(residueType);
	}

	removeDetail(residueType) {
		this.details = this.details.filter((item) => item.id !== residueType.id)
	}

	creation() {
		super.creation();
		this.state = "CREATED";
	}


	isValid() {
		if (this.communicationChannel == null) return false
		if (!this.contactInformation.isValid()) return false
		if (!this.location.isValid()) return false
		if (this.contactInformation.phoneNumber.length !== 13) return false
		if (this.details.length === 0) return false
		return true;
	}

}

class ContactInformation {

	constructor(jsonData) {
		if (jsonData == null)
			jsonData = {};
		
		this.name = jsonData.name;
		this.phoneNumber = jsonData.phoneNumber;
	}

	isValid() {
		if (!this.name) return false;
		return true;
	}

}

class Location {

	constructor(jsonData) {
		if (jsonData == null)
			jsonData = {};

		this.address = jsonData.address;
		this.zoneId = jsonData.zoneId;
		if (jsonData.coordinate != null)
			this.coordinate = new Coordinate(jsonData.coordinate);
		if (jsonData.zone != null)
			this.zone = new Zone(jsonData.zone);
	}

	isValid() {
		if (!this.address) return false;
		if (!this.zone) return false;
		if (!this.coordinate) return false;
		return true;
	}

	setZone(zone) {
		if (zone == null) {
			this.zone = null;
		} else {
			this.zone = zone;
		}
	}

}

class Zone {

	constructor(jsonData) {
		if (jsonData == null)
			jsonData = {};
		
		this.id = jsonData.id;
		this.name = jsonData.name;
		this.days = jsonData.days;
		this.area = { "coordinates": [] };

		if (jsonData.area != null) {
			for (let index = 0; index < jsonData.area.coordinates.length; index++) {
				this.addCoordinate(new Coordinate(jsonData.area.coordinates[index]));
			}
		}
	}

	addCoordinate(coordinate) {
		this.area.coordinates.push(coordinate);
	}

	isEnabled(date) {
		let dayIndex = date.getDay()
		return (this.days[dayIndex]);
	}

	contains(location) {
		let contains = false;
		let i = 0;
		let j = this.area.coordinates.length - 1;
		while (i < this.area.coordinates.length) {
			if (this.area.coordinates[i].latitude > location.latitude !== this.area.coordinates[j].latitude
				> location.latitude && location.longitude < (this.area.coordinates[j].longitude - this.area.coordinates[i]
					.longitude) * (location.latitude - this.area.coordinates[i]
					.latitude) / (this.area.coordinates[j].latitude - this.area.coordinates[i]
					.latitude) + this.area.coordinates[i].longitude)
				contains = !contains;
			j = i++;
		}
		return contains;
	}

}


class Dashboard {

	constructor(jsonData) {
		if (jsonData == null)
			jsonData = {};
		
		this.appointments = [];
		if (jsonData.appointments != null) {
			for (let index = 0; index < jsonData.appointments.length; index++) {
				this.addAppointment(new Appointment(jsonData.appointments[index]));
			}
		}

		this.zones = [];
		if (jsonData.zones != null) {
			for (let index = 0; index < jsonData.zones.length; index++) {
				this.addZone(new Zone(jsonData.zones[index]));
			}
		}

		this.residueTypes = [];
		if (jsonData.residueTypes != null) {
			for (let index = 0; index < jsonData.residueTypes.length; index++) {
				this.addResidueType(new ResidueType(jsonData.residueTypes[index]));
			}
		}

	}

	addAppointment(appointment) {
		this.appointments.push(appointment);
	}

	addResidueType(residueType) {
		this.residueTypes.push(residueType);
	}

	addZone(zone) {
		this.zones.push(zone);
	}

}

const CommunicationChannel = {
	PHONE_CALL: "phone_call",
	WHATSAPP: "whatsapp",
	OFFICE: "office"
}

export { ResidueType, Appointment, Dashboard, CommunicationChannel }